<script>
import resources from './resources'

export default {
  name: 'gadget-upcoming',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-paciente-proximo-evento.white-bg.wrapper.full-width.gadget

    modal(:visible="showModal", className="agendamento-paciente", @close="showModal = false")
      index-details(v-if="showModal", :schedule-id="currentSchedule.id", :showDetailsModal1="true")

    .gadget-title
      | Próximos Eventos
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    div.row(v-if="schedules.length < 1")
      h2
        center Nenhum evento agendado
    div.row(v-if="schedules.length > 0", v-for="schedule in schedules", :key="schedule.id", @click.prevent='setSchedule(schedule)')
        .item(style="cursor: pointer;")
          .col-xs-12.col-sm-6.col-md-2
            label.light-blue Data
            h2.medium-gray {{ schedule.date }}
          .col-xs-12.col-sm-6.col-md-2
            label.light-blue Horário
            h2.medium-gray {{ schedule.time }}
          .col-xs-12.col-md-5
            label.light-blue Profissional
            h4.medium-gray {{ schedule.professional.name }}
            label.light-blue Paciente
            h4.medium-gray {{ schedule.patient.name }}
            //- Relacionamento tipo de dependente
            //- template(v-if="schedule.degree")
              |  ({{ schedule.degree }})
          .col-xs-12.col-md-3
            label.light-blue Especialidade
            h4.medium-gray {{ schedule.speciality }}
            label.light-blue Convênio
            h4.medium-gray {{ schedule.covenant }}
</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/upcoming/upcoming.vue